module.exports = __webpack_public_path__ + "static/media/section2_2.7318241a.png";